// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_html2canvas_dist_html2canvas_js":"8cf6c63c018ccc61","node_modules_dompurify_dist_purify_js":"a9a543cae81bfa61","node_modules_canvg_lib_index_es_js":"1531e8ad0f650c81"}[chunkId] + ".js";
};